import {PRICES_CITIES} from "@pg-rp/navigation";

export const cityNameWhere = (cityName: string) => {
    const selectedCity = PRICES_CITIES.find((city) => city.name === cityName);
    if (selectedCity) {
        return selectedCity.where;
    }
    return "";
};

export const cityPronounWhere = (cityName: string) => {
    if (cityName === "Wrocław") {
        return "we";
    }

    return "w";
};
import {PRICES_CITIES} from "@pg-rp/navigation";

export const cityNameWhere = (cityName: string) => {
    const selectedCity = PRICES_CITIES.find((city) => city.name === cityName);
    if (selectedCity) {
        return selectedCity.where;
    }
    return "";
};

export const cityPronounWhere = (cityName: string) => {
    if (cityName === "Wrocław") {
        return "we";
    }

    return "w";
};
